import { Breadcrumb, Typography, Flex } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { neutral, typography, spacing, border } from "../../theme/tokens";

/**
 * Shared page header — breadcrumb + title/subtitle + optional extra slot.
 * Enterprise-tone: hairline divider, neutral colours, không accent strip.
 */
export default function PageHeader({ title, subtitle, breadcrumb = [], extra }) {
  const breadcrumbItems = [
    {
      title: (
        <Link to="/" style={{ color: neutral[500] }}>
          <HomeOutlined />
        </Link>
      ),
    },
    ...breadcrumb,
  ];

  return (
    <div
      style={{
        background: neutral[0],
        padding: `${spacing[5]}px ${spacing[6]}px ${spacing[4]}px`,
        borderBottom: border.hairline,
      }}
    >
      <Breadcrumb
        items={breadcrumbItems}
        style={{
          marginBottom: spacing[2],
          fontSize: typography.size.sm,
        }}
      />
      <Flex justify="space-between" align="center" gap={16} wrap="wrap">
        <div>
          <Typography.Title
            level={4}
            style={{
              margin: 0,
              color: neutral[900],
              fontWeight: typography.weight.semibold,
              fontSize: typography.size.xl,
              letterSpacing: "-0.01em",
            }}
          >
            {title}
          </Typography.Title>
          {subtitle && (
            <Typography.Text
              style={{
                color: neutral[500],
                fontSize: typography.size.base,
                marginTop: spacing[1],
                display: "block",
                lineHeight: typography.leading.normal,
              }}
            >
              {subtitle}
            </Typography.Text>
          )}
        </div>
        {extra && <div>{extra}</div>}
      </Flex>
    </div>
  );
}
